let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

/* =====================================================================
   MAGIE DES LUTINS - Bandeau "Nouveautés" sur la page d'accueil
   ---------------------------------------------------------------------
   Ajout maison (ne fait pas partie du thème d'origine).
   Affiche un bandeau cliquable tout en haut de la page d'accueil
   uniquement, qui renvoie vers la collection Nouveautés.
   Pour changer le texte ou la date : modifier TEXTE ci-dessous.
   Pour retirer le bandeau : supprimer tout ce bloc.
   ===================================================================== */
(function () {
  var TEXTE = 'Les nouveautés du 11 octobre sont en ligne';
  var BOUTON = 'Je découvre';
  var LIEN = '/collections/nouveautes';

  function estAccueil() {
    var chemin = window.location.pathname.replace(/\/+$/, '');
    return chemin === '' || /^\/[a-z]{2}(-[a-z]{2})?$/i.test(chemin);
  }

  function styles() {
    if (document.getElementById('bandeau-nv-style')) return;
    var s = document.createElement('style');
    s.id = 'bandeau-nv-style';
    s.textContent = [
      '.bandeau-nv{display:flex;align-items:center;justify-content:center;gap:14px;flex-wrap:wrap;',
      'max-width:1100px;margin:18px auto;padding:14px 22px;background:#fdf1e7;',
      'border:2px dashed #c9962e;border-radius:14px;text-decoration:none;color:#991414;',
      'font-weight:700;text-align:center;box-shadow:0 2px 8px rgba(153,20,20,.06);',
      'transition:transform .15s ease,box-shadow .15s ease}',
      '.bandeau-nv:hover{transform:translateY(-1px);box-shadow:0 4px 14px rgba(153,20,20,.12)}',
      '.bandeau-nv__texte{font-size:1.7rem;line-height:1.3}',
      '.bandeau-nv__etoile{margin-right:8px}',
      '.bandeau-nv__btn{display:inline-block;padding:9px 20px;background:#991414;color:#fff;',
      'border-radius:999px;font-size:1.4rem;letter-spacing:.03em;white-space:nowrap}',
      '@media screen and (max-width:749px){',
      '.bandeau-nv{margin:12px 16px;padding:12px 16px;gap:10px}',
      '.bandeau-nv__texte{font-size:1.45rem}',
      '.bandeau-nv__btn{font-size:1.3rem;padding:8px 16px}}'
    ].join('');
    document.head.appendChild(s);
  }

  function poser() {
    if (!estAccueil()) return;
    if (document.getElementById('bandeau-nouveautes')) return;
    var cible = document.getElementById('MainContent') || document.querySelector('main');
    if (!cible) return;

    styles();

    var lien = document.createElement('a');
    lien.id = 'bandeau-nouveautes';
    lien.className = 'bandeau-nv';
    lien.href = LIEN;

    var texte = document.createElement('span');
    texte.className = 'bandeau-nv__texte';
    var etoile = document.createElement('span');
    etoile.className = 'bandeau-nv__etoile';
    etoile.textContent = '✨';
    texte.appendChild(etoile);
    texte.appendChild(document.createTextNode(TEXTE));

    var bouton = document.createElement('span');
    bouton.className = 'bandeau-nv__btn';
    bouton.textContent = BOUTON;

    lien.appendChild(texte);
    lien.appendChild(bouton);
    cible.insertBefore(lien, cible.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser);
  } else {
    poser();
  }
})();